module.exports = __webpack_public_path__ + "static/img/zhuziEffect.3c42bbd4.png";